import { render } from "./AdminStage.vue?vue&type=template&id=64eb6ac1&scoped=true&ts=true&lang=pug"
import script from "./AdminStage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminStage.vue?vue&type=script&lang=ts&setup=true"

import "./AdminStage.vue?vue&type=style&index=0&id=64eb6ac1&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64eb6ac1"]])

export default __exports__